import PurchaseBreadcrumbsContainer from './PurchaseBreadcrumbsContainer';

export default PurchaseBreadcrumbsContainer;
